module.exports = __webpack_public_path__ + "static/media/testimonio-prebistero-allender.949635ac.png";